import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./container/Dashboard/dashboard";
import AppLayout from "./container/AppLayout/AppLayout";
import Unauthorize from "./container/Errors/unauthorize";

export default function App() {
  return (
    <Routes>
      <Route index element={<Navigate to="/dashboard" />} />
      <Route path="/unauthorize" element={<Unauthorize />} />
      <Route element={<AppLayout />}>
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
